import React, { useContext, useState } from "react";
import {
	Container,
	Row,
	Col,
	Table,
	ListGroup,
	Card,
	Button,
} from "react-bootstrap";
import { UserContext } from "../../../Context/UserContextAPI";
import { format } from "date-fns";
import ModalLayout from "../../../components/Layout/ModalLayout";
import AddSubscriptionPayment from "./AddSubscriptionPayment";
import SubscriptionInvoicePage from "./SubscriptionInvoicePage";
import request from "../../../utils/request";
import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useGetSoftwareInformationById } from "../../../API/softwareInformation.api";
import { useGetAllSubscriptionPayment } from "../../../API/subscriptionPayment.api";
import calculateDueMonths from "../../../utils/calculateDueMonths";
import SubscriptionPay from "./SubscriptionPay";

const dueMonthStart = new Date("01-01-2025");

// Helper to format date as "YYYY-MM" for easy comparison

const SubscriptionPaymentInvoice = () => {
	const { currentUser, settingsData } = useContext(UserContext);

	const { data: softwareInformation } = useGetSoftwareInformationById(1);

	return (
		<div className="">
			<div className="d-flex justify-content-end gap-2 print-hidden">
				<Button variant="primary" onClick={() => window.print()}>
					Print Invoice
				</Button>
				<SubscriptionPay />
			</div>
			<SubscriptionInvoicePage />
		</div>
	);
};

export default SubscriptionPaymentInvoice;
